// Picking · lista do dia, confirmação cega, scan QR
import { repo, db } from '../client.js';
import { escapeHTML, QTY, DT, SHORT, BRL } from '../shared.js';

export async function viewPicking($c) {
  $c.innerHTML = `
    <header class="page-head">
      <div>
        <div class="kicker">OPERAÇÃO DE EXPEDIÇÃO</div>
        <h1>Picking <strong>do dia</strong></h1>
        <p class="lead">Pedidos a separar. Cada item é confirmado cegamente — o sistema confronta com a NF depois. Atalho: clique no número da lista para abrir a conferência.</p>
      </div>
      <div class="page-head-actions">
        <button class="btn btn-blue" id="btn-novo-picking">+ Nova lista de picking</button>
      </div>
    </header>

    <div class="card">
      <div class="card-head"><h2>Listas pendentes <span class="count" id="pck-count">…</span></h2></div>
      <div id="pck-list"></div>
    </div>

    <div class="card mt-md" id="pck-detail-card" style="display:none;">
      <div class="card-head"><h2 id="pck-detail-title">Detalhe</h2>
        <div class="row gap-sm">
          <button class="btn-mini" id="btn-close-detail">Fechar</button>
        </div>
      </div>
      <div id="pck-detail-body"></div>
    </div>

    <div class="grid-2 mt-md">
      <div class="card">
        <div class="card-head"><h2>Conferência cega · regra</h2></div>
        <ol style="padding-left: 20px; line-height: 1.8; font-size: 14px;">
          <li>Operador A pega cada item da lista e <strong style="font-weight:500;">não vê</strong> a quantidade planejada</li>
          <li>Conta o que pegou e confirma</li>
          <li>Sistema só revela divergência depois — vira exceção investigada</li>
          <li>Operador B faz validação cega no fechamento</li>
        </ol>
      </div>
      <div class="card">
        <div class="card-head"><h2>Como criar pedidos</h2></div>
        <p class="body">Picking pode vir de 3 fontes:</p>
        <ul class="clean">
          <li>Vinculado a NF outbound já carregada (combo abaixo)</li>
          <li>Vinculado a remessa sem nota (RMA, demo)</li>
          <li>Ad-hoc — apenas pedido + destinatário</li>
        </ul>
      </div>
    </div>
  `;

  // listar pendentes
  let pendentes = [];
  try { pendentes = await repo.pickingPendentes(); } catch (e) { console.error(e); }

  const listEl = document.getElementById('pck-list');
  document.getElementById('pck-count').textContent = pendentes.length;
  if (pendentes.length === 0) {
    listEl.innerHTML = '<div class="empty">Nenhum picking pendente. Clique em <strong>+ Nova lista</strong> para começar.</div>';
  } else {
    listEl.innerHTML = `
      <table class="tbl">
        <thead><tr><th>Número</th><th>Status</th><th>Prio</th><th>Destinatário</th><th>Cidade</th><th class="num">Itens</th><th class="num">Separados</th><th>Picker</th><th>Criado</th><th></th></tr></thead>
        <tbody>${pendentes.map(p => `
          <tr data-pid="${p.id}" class="row-clickable">
            <td class="mono strong">${escapeHTML(p.numero)}</td>
            <td><span class="pill ${pillStatus(p.status)}">${escapeHTML(p.status)}</span></td>
            <td class="num">${p.prioridade}</td>
            <td>${escapeHTML(SHORT(p.destinatario || '—', 30))}</td>
            <td class="text-mute">${escapeHTML(p.cidade_destino || '')}</td>
            <td class="num">${p.total_itens || 0}</td>
            <td class="num"><span class="pill ${Number(p.itens_separados) === Number(p.total_itens) && p.total_itens > 0 ? 'pill-green' : 'pill-mute'}">${p.itens_separados || 0}/${p.total_itens || 0}</span></td>
            <td>${escapeHTML(p.picker || '—')}</td>
            <td class="mono text-sm">${DT(p.created_at)}</td>
            <td><button class="btn-mini" data-open="${p.id}">abrir →</button></td>
          </tr>`).join('')}
        </tbody>
      </table>`;
    listEl.querySelectorAll('[data-open]').forEach(b => b.addEventListener('click', () => abrirDetalhe(parseInt(b.dataset.open, 10))));
  }

  // ─── Detalhe / conferência ────────────────────────────────────────────
  async function abrirDetalhe(id) {
    const card = document.getElementById('pck-detail-card');
    const body = document.getElementById('pck-detail-body');
    card.style.display = 'block';
    document.getElementById('pck-detail-title').textContent = `Picking #${id}`;
    body.innerHTML = '<div class="empty"><span class="spinner"></span>Carregando…</div>';
    try {
      const [{ data: pl }, itens] = await Promise.all([
        db.from('picking_list').select('*').eq('id', id).maybeSingle(),
        repo.pickingItens(id),
      ]);
      if (!pl) { body.innerHTML = '<div class="empty err">Não encontrado.</div>'; return; }
      body.innerHTML = `
        <div class="grid-3 mb-md">
          <div><div class="kicker">DESTINATÁRIO</div><div class="strong">${escapeHTML(pl.destinatario || '—')}</div><div class="text-mute text-sm">${escapeHTML(pl.cidade_destino || '')}</div></div>
          <div><div class="kicker">STATUS</div><span class="pill ${pillStatus(pl.status)}">${escapeHTML(pl.status)}</span></div>
          <div><div class="kicker">PICKER</div><div>${escapeHTML(pl.picker || '— sem atribuir —')}</div></div>
        </div>
        <table class="tbl">
          <thead><tr><th>#</th><th>SKU</th><th>Descrição</th><th>Endereço</th><th class="num">Plan.</th><th class="num">Sep.</th><th>Volume</th><th>Status</th><th></th></tr></thead>
          <tbody>${itens.map((it, i) => `
            <tr>
              <td>${it.ordem || i + 1}</td>
              <td class="mono">${escapeHTML(SHORT(it.sku_codigo || '—', 20))}</td>
              <td>${escapeHTML(SHORT(it.descricao || '', 42))}</td>
              <td class="mono">${escapeHTML(it.endereco_alvo || '—')}</td>
              <td class="num"><span class="masked-qty">${Number(it.qtd_separada) >= Number(it.qtd_planejada) ? QTY(it.qtd_planejada) : '<span class="text-mute">cega</span>'}</span></td>
              <td class="num"><input class="qty-inp" type="number" data-item="${it.id}" value="${it.qtd_separada || 0}" step="0.01" min="0" /></td>
              <td><input class="vol-inp" type="text" data-item="${it.id}" value="${escapeHTML(it.volume_codigo || '')}" placeholder="scan VOL-..." /></td>
              <td>${it.separado_em ? '<span class="pill pill-green">✓ separado</span>' : '<span class="pill pill-mute">aguardando</span>'}</td>
              <td><button class="btn-mini" data-conf="${it.id}">confirmar</button></td>
            </tr>`).join('')}
          </tbody>
        </table>
        <div class="row gap-sm mt-md">
          <button class="btn btn-blue" id="btn-status-iniciar" ${pl.status !== 'planejado' && pl.status !== 'liberado' ? 'disabled' : ''}>Iniciar picking</button>
          <button class="btn btn-blue" id="btn-status-conferir">Aguardando conferência</button>
          <button class="btn btn-green" id="btn-status-concluir">✓ Concluir</button>
        </div>
      `;
      body.querySelectorAll('[data-conf]').forEach(b => b.addEventListener('click', async () => {
        const itemId = parseInt(b.dataset.conf, 10);
        const qtyInp = body.querySelector(`.qty-inp[data-item="${itemId}"]`);
        const volInp = body.querySelector(`.vol-inp[data-item="${itemId}"]`);
        try {
          await repo.confirmarItemPicking(itemId, { qtd_separada: parseFloat(qtyInp.value || '0'), volume_codigo: volInp.value || null });
          abrirDetalhe(id);
        } catch (err) { alert('Erro: ' + err.message); }
      }));
      document.getElementById('btn-status-iniciar').addEventListener('click', async () => {
        await repo.atualizarPicking(id, { status: 'em_andamento', iniciado_em: new Date().toISOString() });
        abrirDetalhe(id);
      });
      document.getElementById('btn-status-conferir').addEventListener('click', async () => {
        await repo.atualizarPicking(id, { status: 'aguardando_conferencia' });
        abrirDetalhe(id);
      });
      document.getElementById('btn-status-concluir').addEventListener('click', async () => {
        await repo.atualizarPicking(id, { status: 'concluido', concluido_em: new Date().toISOString() });
        viewPicking($c);
      });
    } catch (err) { body.innerHTML = `<div class="empty err">${escapeHTML(err.message)}</div>`; }
  }

  document.getElementById('btn-close-detail').addEventListener('click', () => {
    document.getElementById('pck-detail-card').style.display = 'none';
  });

  // ─── Nova lista ───────────────────────────────────────────────────────
  document.getElementById('btn-novo-picking').addEventListener('click', () => abrirCriarPicking($c));
}

async function abrirCriarPicking($c) {
  // dialog inline
  const body = document.getElementById('pck-detail-body');
  const card = document.getElementById('pck-detail-card');
  card.style.display = 'block';
  document.getElementById('pck-detail-title').textContent = 'Nova lista de picking';
  body.innerHTML = `
    <form id="new-pck-form" class="form-stack" style="max-width:700px;">
      <div class="grid-2">
        <label>Destinatário<input id="np-dest" required placeholder="ex: TELEFONICA BRASIL S.A."></label>
        <label>Cidade destino<input id="np-cidade" placeholder="ex: São Paulo/SP"></label>
        <label>Nº pedido<input id="np-pedido" placeholder="opcional"></label>
        <label>Prioridade<input id="np-prio" type="number" min="1" max="9" value="5"></label>
      </div>
      <h3 class="mt-md mb-sm">Itens (SKU, qtd, endereço sugerido)</h3>
      <div id="np-itens"></div>
      <button type="button" class="btn-mini" id="np-add-item">+ adicionar item</button>
      <div class="row gap-sm mt-md">
        <button type="submit" class="btn btn-blue">Criar picking</button>
      </div>
    </form>
  `;
  const itensWrap = document.getElementById('np-itens');
  const addItem = () => {
    const div = document.createElement('div');
    div.className = 'row gap-sm mb-sm';
    div.innerHTML = `
      <input class="np-sku" placeholder="SKU código" style="flex:2;">
      <input class="np-desc" placeholder="descrição (opcional)" style="flex:3;">
      <input class="np-qtd" type="number" placeholder="qtd" step="0.01" min="0" style="flex:1;">
      <input class="np-end" placeholder="endereço" style="flex:1;">
      <button type="button" class="btn-mini" data-rm>×</button>
    `;
    div.querySelector('[data-rm]').addEventListener('click', () => div.remove());
    itensWrap.appendChild(div);
  };
  addItem(); addItem();
  document.getElementById('np-add-item').addEventListener('click', addItem);

  document.getElementById('new-pck-form').addEventListener('submit', async (e) => {
    e.preventDefault();
    const dest = document.getElementById('np-dest').value;
    const cidade = document.getElementById('np-cidade').value;
    const pedido = document.getElementById('np-pedido').value;
    const prio = parseInt(document.getElementById('np-prio').value || '5', 10);
    const itens = [];
    itensWrap.querySelectorAll('.row').forEach(r => {
      const sku = r.querySelector('.np-sku').value.trim();
      if (!sku) return;
      itens.push({
        sku_codigo: sku,
        descricao: r.querySelector('.np-desc').value || null,
        qtd: parseFloat(r.querySelector('.np-qtd').value || '1'),
        endereco_alvo: r.querySelector('.np-end').value || null,
      });
    });
    try {
      await repo.criarPicking({ destinatario: dest, cidade_destino: cidade, pedido_cliente: pedido, prioridade: prio, itens });
      viewPicking($c);
    } catch (err) { alert('Erro: ' + err.message); }
  });
}

function pillStatus(s) {
  return {
    planejado: 'pill-mute',
    liberado: 'pill-blue',
    em_andamento: 'pill-amber',
    aguardando_conferencia: 'pill-amber',
    concluido: 'pill-green',
    cancelado: 'pill-red',
  }[s] || 'pill-mute';
}
